import React from 'react';
import {FormattedNumber, injectIntl} from 'react-intl';
import { Row, Col, OverlayTrigger, Popover, Alert, DropdownButton, MenuItem, Clearfix } from 'react-bootstrap';
import { getThumbFile } from 'helpers/items';
import {forEach as _forEach} from "lodash";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getNameInCurrentLanguage} from "helpers/intl";
import { S3_LINKS_DIV } from 'js/constants';

class OrderItemsCustomer extends React.Component {
  render() {
    const { order,  intl: { messages }, } = this.props;
    let print_amount;
    return order.items.map((item, index) => {
      if(item.variant !== null) {
        _forEach(item.variant.attributes, (attributes, j) => {
          _forEach(attributes.name, (name, j) => {
            if (name.name === "Auflage") {
              print_amount = attributes.values[0].value[0].name
            }
          })
        })
      }
        return (
          <div key={item.id} class="clearfix">
            {index === 0 &&
            <Row className="orderDetailsRowHeader">
              <Col xs={2} md={2}>
                <h5></h5>
              </Col>
              <Col xs={4} md={4}>
                <h5>{messages.order_item}</h5>
              </Col>
              <Col xs={2} md={2}>
                <h5>{messages.order_price}</h5>
              </Col>
              <Col xs={2} md={2}>
                <h5>{messages.order_quantity}</h5>
              </Col>
              <Col xs={2} md={2}>
                <h5>{messages.order_copies}</h5>
              </Col>
            </Row>
            }
<Row className="orderDetailsRow">
  <Col xs={2} md={2}>
    {item.edition && item.edition.previews && item.edition.previews[0] && item.edition.previews[0].key ?
      <img src={item.edition.previews[0].key} style={{maxWidth:"100%", maxHeight:"200px"}} />
      : item.code!=='WEB_PDF' && item.code!=='DATA_CHECK' && <img src={S3_LINKS_DIV.PDF_IMAGE_DEFAULT} style={{maxWidth:"100%", maxHeight:"200px"}} />}
      </Col>
  <Col xs={4} md={4}>
    <p>{item.edition ? item.edition.title : null}</p>
    <p>{item.description ? <span class="hint-text">{item.description}</span> : null}</p>
    <p>{getNameInCurrentLanguage(item.name, this.props.appIntl)}</p>
  </Col>
  <Col xs={2} md={2}>
    <p> <FormattedNumber value={item.gross_price} style="currency" currency={order.currency}/></p>
  </Col>
  <Col xs={2} md={2}>
    <p> {item.quantity ? item.quantity + 'x ' : null}</p>
  </Col>
  <Col xs={2} md={2}>
    <p>{item.code!=='WEB_PDF' && item.code!=='DATA_CHECK' && print_amount}</p>
  </Col>
</Row>

            {order.items.length-1 === index &&
            <Row className="orderDetailsRow">
             <Col style={{textAlign:"right"}}>
               <h5  style={{textTransform:"uppercase"}}>{messages.order_totals}</h5>
               <p  style={{fontWeight:"bold"}}>{messages.subtotal}</p>
               <p><FormattedNumber value={order.sum_net} style="currency" currency={order.currency}/></p>
               {/*
               <h5>Aktionen</h5>
               <p></p>
               */}
               <p style={{fontWeight:"bold"}}>MwSt. {order.vat_sum_rates[0].rate} %</p>
               <p><FormattedNumber value={order.vat_sum_rates[0].sum} style="currency" currency={order.currency}/></p>
               <h4>{messages.invoice_amount}</h4>
               <h4><FormattedNumber value={order.sum_gross} style="currency" currency={order.currency}/></h4>
             </Col>
            </Row>
            }
          </div>
        );
      });


  }
}



const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OrderItemsCustomer)));
